export default "__VITE_ASSET__JPyGWDKC__"